export default "__VITE_ASSET__DLipZ1in__"